import React, {useEffect, useState} from 'react';
import {TagSmall} from '@wix/wix-ui-icons-common/on-stage';
import {SummaryDataHooks} from '../AsideSummary/AsideSummary';
import {useControllerProps} from '../../Widget/ControllerContext';
import {CodeInputSection} from '../CodeInputSection/CodeInputSection';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';

export enum CouponInputDataHooks {
  enterACodeButtonDisabledTooltip = 'CouponInput.enterACodeButtonDisabledTooltip',
}

export const CouponInput: React.FC<{mobilePosition?: string}> = ({mobilePosition}) => {
  const localeKeys = useLocaleKeys();
  const {cart, cartSummary, applyCouponError, applyCoupon, removeCoupon, onAddCouponSectionOpen, isCouponUpdating} =
    useControllerProps().checkoutStore;

  const [couponCodeError, setCouponCodeError] = useState(applyCouponError ? applyCouponError.description : undefined);

  useEffect(() => {
    const error = applyCouponError ?? cartSummary?.errors?.couponError;
    setCouponCodeError(error ? error.description : undefined);
  }, [cartSummary, applyCouponError, localeKeys]);

  const handleAddCouponSectionOpen = () => {
    onAddCouponSectionOpen(mobilePosition);
  };

  const handleApplyCode = (couponCode: string) => {
    void applyCoupon(couponCode, mobilePosition);
  };

  const handleRemoveCode = () => {
    void removeCoupon(mobilePosition);
  };

  const enterACodeButtonDisabledTooltipData = {
    dataHook: CouponInputDataHooks.enterACodeButtonDisabledTooltip,
    content: localeKeys.checkout.paymentDetails.applyCoupon.cantPurchaseGC.tooltip(),
  };

  return (
    <CodeInputSection
      dataHook={SummaryDataHooks.couponSectionInput}
      enterACodeButtonText={localeKeys.checkout.coupon.label()}
      onCodeInputOpen={handleAddCouponSectionOpen}
      applyCodeText={localeKeys.checkout.coupon.applyButton()}
      removeCodeText={localeKeys.checkout.coupon.removeButton()}
      codeValue={cart.coupon?.code}
      onApplyCode={handleApplyCode}
      onRemoveCode={handleRemoveCode}
      error={couponCodeError}
      icon={<TagSmall />}
      placeholder={localeKeys.checkout.paymentDetails.enterPromoCode.placeholder()}
      isUpdating={isCouponUpdating}
      isLoading={!cartSummary}
      isEnterACodeButtonDisabled={cart.hasGiftCardItems}
      enterACodeButtonDisabledTooltipData={enterACodeButtonDisabledTooltipData}
      ariaLabel={localeKeys.checkout.coupon.inputCode.ariaLabel()}
    />
  );
};
